// Themes
export const THEMES = {
  DEFAULT: "DEFAULT",
  DARK: "DARK",
  LIGHT: "LIGHT",
  BLUE: "BLUE",
  GREEN: "GREEN",
  INDIGO: "INDIGO",
};

// Send For Approval Constants
export const SHEET = {
  SHEET_TYPE: "COMMON_PRICING_SHEET",
  AUDIT_SHEET_TYPE: "AUDIT_REFERENCE_SHEET",
  ERROR_MESSAGES: {
    INSTANCE_ID_REQUIRED: "Instance ID is required",
    COLUMNS_REQUIRED: "Columns data is required and must be an array",
    TABLE_DATA_REQUIRED: "Table data is required and must be an array",
  },
} as const;

// export const JAVA_PORTAL_SERVER = {
//   BASE_URL: "http://localhost:8080/core-service",
//   PRICING_AUDIT_TOOL_URI: "/api/v1/pricing-audit-tool",
// } as const;
